import React,  {useState, useEffect} from "react"
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';



function Desafio({dia, returnToCalendar}){
  
  const [data, setData] = useState([{}])
  const [showRespostaCorrecta, setShowRespostaCorrecta] = useState(false);
  const [showRespostaErrada, setShowRespostaErrada] = useState(false);

  const handleClose = () => {
    setShowRespostaCorrecta(false);
    setShowRespostaErrada(false);
    returnToCalendar();
  }
  const handleShowRespostaCorrecta = () => setShowRespostaCorrecta(true);
  const handleShowRespostaErrada = () => setShowRespostaErrada(true);
  
  const voltarAoCalendario = () => {
    handleClose();
    returnToCalendar();
  }

  function resolverDesafio(){
    if(localStorage.getItem("score") === null){
      //localStorage.setItem("score", JSON.stringify({desafios:[]}));
      
    }
    let sessionId = localStorage.getItem("sessionId");

    

    let solucao = data.desafio.solution.replaceAll(",", ".").toUpperCase()
    let resposta = String(data.resposta).replaceAll(",", ".").toUpperCase()

    console.log("resp = " + resposta + "sol=" + data.desafio.solution)

    fetch('https://www.araquelexplica-te.pt/custom/natal2022/resolver_desafio.php?dia=' + dia + '&resposta=' + resposta + '&session_id=' + sessionId).then(res => res.json()).then(response => {
      console.log(response.result);
    });

    if(solucao === resposta){
        localStorage.setItem("desafio" + data.desafio.dia, "correcto");
        handleShowRespostaCorrecta();
    }else{
      localStorage.setItem("desafio" + data.desafio.dia, "errado");
      handleShowRespostaErrada();
    }
    //localStorage.setItem("score", JSON.stringify(score));
  }

  function setResposta(resposta){
    data.resposta = resposta;
    resolverDesafio();
  }

  
  useEffect(() => {
    fetch("https://www.araquelexplica-te.pt/custom/natal2022/desafio.php?dia="+dia).then(
      res => res.json()
    ).then(
      data => {
        setData(data)
      }
    )
  }, [dia])
  return(
    <div>
      {(typeof data.desafio === 'undefined')? (
        <p>A carregar desafio...</p>
      ):(
        <div>
          <img src={"https://www.araquelexplica-te.pt/custom/natal2022/static/desafios/" + dia + ".png"} alt={"dia " + dia} width="80%"></img>  

          {
            data.desafio.tipo === 'resposta' ? (
              <div class="input-group mb-3">
                
                { (dia == 16)? 
                (<input type="text" class="form-control" placeholder="" onChange={(evt) => data.resposta = evt.target.value}  />): 
                (<input type="text" class="form-control" placeholder="" onChange={(evt) => data.resposta = evt.target.value}  />) }

                


                <button type="button" class="btn btn-primary" onClick={() => resolverDesafio()}>Submeter resposta</button>
              </div>
              
            ):(
              <div  class="row" style={{marginTop: "40px"}}>
                <div class="col"><button class="btn btn-primary" type="button" style={{backgroundColor:"#CB9CFC", border: "0px",  width:"80%", height:"80px", fontSize:"25px"}} onClick={() => setResposta('a')}>{data.desafio.opcoes.a.toUpperCase()}</button></div>
                <div class="col"><button class="btn btn-primary" type="button" style={{backgroundColor:"#93CD58", border: "0px",   width:"80%", height:"80px", fontSize:"25px"}} onClick={() => setResposta('b')}>{data.desafio.opcoes.b.toUpperCase()}</button></div>
                <div class="col"><button class="btn btn-primary" type="button" style={{backgroundColor:"#FB28FC", border: "0px",   width:"80%", height:"80px", fontSize:"25px"}} onClick={() => setResposta('c')}>{data.desafio.opcoes.c.toUpperCase()}</button></div>
                {(typeof data.desafio.opcoes.d !== 'undefined') ? (
                <div class="col"><button class="btn btn-primary" type="button" style={{backgroundColor:"#6F359E", border: "0px",   width:"80%", height:"80px", fontSize:"25px"}} onClick={() => setResposta('d')}>{data.desafio.opcoes.d.toUpperCase()}</button></div>
                ):("")}
                
              </div>
            )
          }
          <button type="button" class="btn btn-outline-secondary btn-lg" style={{marginTop: "20px"}} onClick={() => returnToCalendar()}> Voltar ao calendário</button>
        </div>
      )}


      {/* Modal para resposta correcta */}
      <Modal 
      show={showRespostaCorrecta} 
      onHide={handleClose} 
      centered>
        <Modal.Header closeButton>
          <Modal.Title>Parabéns!</Modal.Title>
        </Modal.Header>
        <Modal.Body>A tua resposta está correcta</Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={voltarAoCalendario}>
            Ok
          </Button>
        </Modal.Footer>
      </Modal>


        {/* Modal para resposta errada */}
        <Modal 
        show={showRespostaErrada} 
        onHide={handleClose}
        centered>
        <Modal.Header closeButton>
          <Modal.Title>Resposta errada</Modal.Title>
        </Modal.Header>
        <Modal.Body>A tua resposta está errada. Volta ao calendário para tentares outro desafio.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={voltarAoCalendario}>
            Voltar ao calendário
          </Button>
        </Modal.Footer>
      </Modal>

    </div>
  )
}

export default Desafio;